import React from 'react'

import { Controller } from 'react-hook-form'

import { Textarea } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, object } from 'prop-types'

import useUseCaseTranslate from 'Pods/LazyLoaded/UseCaseAreaSidebar/hooks/useUseCaseTranslate'

import { DESCRIPTION_MAX_LENGTH } from '../../../../Utils/Data'

function DescriptionForm({
  control,
  disabled,
}) {
  const { tv } = useUseCaseTranslate()

  return (
    <div className="use-cases-area__description-container">
      <span className="use-cases-area__label cgt-body-base-semibold cgt-mb-4">
        {tv('form.descriptionLabel')}
      </span>
      <Controller
        name="description"
        control={control}
        render={({ field }) => (
          <Textarea
            {...field}
            id="use-case-description"
            placeholder={tv('form.descriptionPlaceholder')}
            disabled={disabled}
            maxLength={DESCRIPTION_MAX_LENGTH}
            textareaClassName="use-cases-area__textarea"
            size="small"
            isPilot
          />
        )}
      />
    </div>
  )
}

DescriptionForm.propTypes = {
  control: object.isRequired,
  disabled: bool.isRequired,
}

export default DescriptionForm
